module.exports = __webpack_public_path__ + "static/EddyLeung-bdb56232779f498a8bddd706a5fd6d19.jpg";